<template>
  <div class="document-wrapper">
    <div class="pdf-logo-wrapper">
      <div class="pdf-logo-bce">
        <img src="../../../assets/img/pdf/bce.jpg" height="90px" />
      </div>
    </div>
    <div class="doc-title">
      PAKTA INTEGRITAS PENYEDIA BARANG & JASA (VENDOR)
    </div>
    <div class="pdf-text mt20">Saya yang bertanda tangan di bawah ini:</div>
    <div class="pdf-form-wrapper mt20">
      <div class="pdf-form doc-indent">
        <span>Nama</span>
        <span>: </span>
      </div>
      <div class="pdf-form-content">{{ $route.query.nama }}</div>
    </div>
    <div class="pdf-form-wrapper mt20">
      <div class="pdf-form doc-indent">
        <span>Jabatan</span>
        <span>: </span>
      </div>
      <div class="pdf-form-content">{{ $route.query.jabatan }}</div>
    </div>
    <div class="pdf-form-wrapper mt20">
      <div class="pdf-form doc-indent">
        <span>Perusahaan</span>
        <span>: </span>
      </div>
      <div class="pdf-form-content">{{ $route.query.perusahaan }}</div>
    </div>
    <div class="pdf-form-wrapper mt20">
      <div class="pdf-form doc-indent">
        <span>Alamat</span>
        <span>: </span>
      </div>
      <div class="pdf-form-content">{{ $route.query.alamat }}</div>
    </div>
    <div class="mt20"></div>
    <div class="pdf-text mt20">
      Dalam rangka transaksi bisnis berupa proses pengadaan barang dan jasa
      dengan PT Berau Coal Energy dan seluruh anak perusahaan (“Perusahaan”)
      dengan ini menyatakan sebagai berikut:
    </div>
    <div class="mt20"></div>
    <div>
      <div
        class="pdf-list doc-list-indent"
        v-for="(item, index) in list"
        :key="index"
      >
        <div class="index-col">{{ index + 1 }}.</div>
        <div class="desc-col">{{ item }}</div>
      </div>
    </div>

    <!-- page break -->
    <div class="html2pdf__page-break" />
    <div class="pdf-logo-wrapper" v-show="isVisible">
      <div class="pdf-logo-bce">
        <img src="../../../assets/img/pdf/bce.jpg" height="90px" />
      </div>
    </div>
    <div>
      <div
        class="pdf-list doc-list-indent"
        v-for="(item, index) in list2"
        :key="index"
      >
        <div class="index-col">{{ index + 8 }}.</div>
        <div class="desc-col">{{ item }}</div>
      </div>
    </div>

    <div>
      <div
        class="pdf-list doc-list-indent"
        v-for="(item, index) in sublist"
        :key="index"
      >
        <div class="index-col"></div>
        <div class="pdf-sublist desc-col">
          <div class="index-col">{{ alfabeth[index] }}.</div>
          <div class="desc-col">
            {{ item }}
          </div>
        </div>
      </div>
    </div>

    <div class="pdf-text mt20">
      Demikian Pakta Intergritas ini saya tanda tangani dengan kesadaran guna
      memenuhi salah satu syarat proses pengadaan barang dan jasa dan dalam
      upaya menciptakan/melaksanakan bisnis dengan cara terbuka, jujur dan
      beretika serta menjadi rekanan penyedia barang & jasa/mitra kerja yang
      saling menjaga reputasi masing-masing perusahaan.
    </div>
    <div class="pdf-sign ">
      <div class="pdf-text mt20">Hormat kami,</div>
      <div class="pdf-text mt20 text-center">
        ...............................,{{ formatDate(Date.now()) }}
      </div>
      <div class="pdf-small-text mt20 text-center">
        Materai Rp 10.000 Cap
      </div>
      <div class="pdf-small-text mt20 text-center">Perusahaan</div>
      <div class="pdf-text mt20 text-center">
        ({{
          $get(
            $route,
            'query.nama',
            '........................................................'
          )
        }})
      </div>
    </div>
  </div>
</template>

<script>
import html2pdf from 'html2pdf.js'

export default {
  components: {
    GlobalLoading: () => import('@/components/V2/GlobalLoading.vue'),
  },
  data() {
    return {
      isVisible: false,
      isLoading: false,
      alfabeth: ['a', 'b', 'c', 'd', 'e'],
      list: [
        'Mematuhi dan melaksanakan pedoman etika dan anti penyuapan yang telah dicanangkan dan dijalankan oleh Perusahaan.',
        'Melaksanakan kerja sama bisnis dengan cara yang terbuka, jujur dan beretika/bermoral.',
        'Tidak menawarkan pemberian dalam bentuk/nama apapun termasuk atas dasar pemberian pribadi baik berupa uang, pinjaman uang, tiket perjalanan, voucher penginapan, suguhan hiburan, barang dan/atau jasa kepada Pejabat/Karyawan Perusahaan.',
        'Tidak melakukan persekongkolan/pengaturan/kerjasama diantara para Calon Penyedia  Barang/Jasa  dan/atau Pejabat/Karyawan Perusahaan yang dapat mengakibatkan terjadinya persaingan usaha yang tidak sehat dan pelanggaran etika yang merugikan Perusahaan.',
        'Pejabat/Karyawan perusahaan Penyedia Barang/Jasa tidak memiliki benturan kepentingan dengan Perusahaan baik benturan ekonomi secara langsung ataupun adanya hubungan pribadi atau  keluarga  dengan Pejabat/Karyawan Perusahaan yang membuat perusahaan Penyedia Barang/Jasa  menjadi  tidak patut untuk menjadi rekanan bisnis/mitra kerja.',
        'Melaporkan segala bentuk penyimpangan, pelanggaran dan segala upaya-upaya kecurangan dan ketidakjujuran yang dilakukan Pejabat/Karyawan Perusahaan.',
        'Harga yang ditawarkan adalah harga yang wajar dimana dapat diperbandingkan. Bila di kemudian hari diketahui bahwa harga yang ditawarkan menunjukkan/mengindikasikan adanya ketidakwajaran, maka Penyedia Barang/Jasa sanggup mempertanggungjawabkan dan mengembalikan  kelebihan  harga  tersebut ke Perusahaan.',
      ],
      list2: [
        'Tidak mengungkapkan/membocorkan informasi rahasia yang didapat terkait transaksi bisnis dengan Perusahaan yang dapat merugikan Perusahaan.',
        'Memberikan segala informasi kepada Pimpinan Perusahaan terkait transaksi pengadaan barang dan jasa dengan Perusahaan.',
        'Apabila terjadi pelanggaran atas kebijakan Kode Etik dan anti penyuapan terhadap penyelenggaraan pengadaan barang dan/atau jasa, maka calon penyedia barang dan atau jasa bersedia bekerja sama untuk memberikan, meminjamkan dan atau memperlihatkan data, dokumen dan laporan terkait  baik  berupa softcopy maupun hardcopy kepada Perusahaan.',
        'Bersedia menerima sanksi yang dikenakan sesuai ketentuan Perusahaan ataupun peraturan perundang- undangan yang berlaku apabila diketahui dan terbukti telah melanggar hal-hal  sebagaimana  dinyatakan dalam Pakta Integritas ini.',
        'Pakta integritas Penyedia Barang/Jasa harus ditanda-tangani oleh Direksi/Pimpinan yang  tercantum  di  dalam Akta Perusahaan/Badan Usaha.',
        'Apabila terjadi dugaan Pelanggaran Kode Etik Pengadaan Barang dan Jasa, silahkan  menghubungi salah satu Hotline Pengaduan:',
      ],
      sublist: [
        'Telepon, SMS atau WhatsApp ke nomor 081282196088 /081282363699/ 081251315952; atau',
        'Surat elektronik (Email) ditujukan ke alamat:abc.lapor@gmail.com;whistleblower@sinarmasmining.com;',
        'Setiap laporan mengenai harus dilengkapi dengan bukti sebagai dokumen pendukung dan kerahasiaan pelapor akan dijamin Perusahaan.',
      ],
    }
  },
  methods: {
    getDate() {
      return this.getDate()
    },
    async exportToPDF() {
      this.isVisible = true
      this.isLoading = true
      await html2pdf(this.$refs.document, {
        margin: [0.2, 1],
        filename: 'Dokument Pakta Integritas BCE.pdf',
        image: { type: 'jpeg', quality: 1 },
        html2canvas: { scale: 4, dpi: 192, letterRendering: true },
        jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' },
      })
      this.isVisible = false
      this.isLoading = false
    },
  },
}
</script>
